import { H4 } from 'foundations-components/transitional/components/H4';
import { ErrorMessage as FoundationsErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ErrorMessage = ({
  title,
  body
}) => {
  return /*#__PURE__*/_jsx(FoundationsErrorMessage, {
    illustration: "warning",
    title: /*#__PURE__*/_jsx(H4, {
      children: title
    }),
    illustrationProps: {
      width: '100'
    },
    margin: "500",
    marginBlockStart: "1300",
    children: body
  });
};